import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { TutorialButton } from '@ro-components/Tutorial';

export const tooltipTutorial = (id, buttonText) => [
  {
    element: '.ro_tooltip',
    intro: `Tooltip RO to serce aplikacji. Wszystkie akcje prowadzą właśnie tędy. Tutaj możesz sprawdzić parametry meteorologiczne, siłę opadu, wysokość echa radarowego, sumę opadu, parametry pogodowe na stacjach pomiarowych i wiele innych. To tutaj dodajesz ulubione lokalizacje do listy, sprawdzasz meteogramy, czy podglądasz aktualne ostrzeżenia. Tu bije serce RO.`
  },
  {
    element: '.ro_tooltip',
    intro: `${ReactDOMServer.renderToStaticMarkup(<TutorialButton id={id} text={buttonText} />)}`
  }
];
